export const COURSE_GIFT_DEDICATION_LIMITS = {
  from: 40,
  to: 40,
  message: 180,
} as const;

type CourseGiftDedicationInput = {
  from?: string;
  to?: string;
  message?: string;
} | null;

const trimToLimit = (value: string | undefined, limit: number) => (value?.trim() ?? '').slice(0, limit);

export const normalizeCourseGiftDedication = (dedication: CourseGiftDedicationInput) => {
  if (!dedication) return null;

  return {
    from: trimToLimit(dedication.from, COURSE_GIFT_DEDICATION_LIMITS.from),
    to: trimToLimit(dedication.to, COURSE_GIFT_DEDICATION_LIMITS.to),
    message: trimToLimit(dedication.message, COURSE_GIFT_DEDICATION_LIMITS.message),
  };
};

export const isCourseGiftDedicationWithinLimits = (dedication: CourseGiftDedicationInput) => {
  if (!dedication) return true;

  return (
    (dedication.from?.trim().length ?? 0) <= COURSE_GIFT_DEDICATION_LIMITS.from &&
    (dedication.to?.trim().length ?? 0) <= COURSE_GIFT_DEDICATION_LIMITS.to &&
    (dedication.message?.trim().length ?? 0) <= COURSE_GIFT_DEDICATION_LIMITS.message
  );
};
